import AddButton from "../../../components/AddButton";
import { useRef } from "react";
import { useState } from "react";
import TableFilters from "./TableFilters";
import MassUploadButton from "../../../components/MassUploadButton";
import MassUpload from "./massupload/MassUpload";
import OfficeSettingsForm from "./forms/OfficeSettingsForm";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { CSVLink } from "react-csv";
import {
  ArrowUpCircleIcon,
  FunnelIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import {
  officeAddState,
  officeEditState,
  officeShowState,
} from "./atoms/atoms";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import OfficeSettingsTable from "./OfficeSettingsTable";
import DownloadButton from "../../../components/DownloadButton";
import useOfficeForDownload from "./hooks/useOfficeForDownload";
import { toast } from "../../../components/toastNotification";
import { OFFICE_PERMISSIONS } from "modules/CarrierAgreementMgmt/OfficeSettings/permission";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

const OfficeSettingsMain = ({
  data = [],
  filterOfficeSettings,
  setFilterStatus,
  setFilteredOfficeData,
  setresetStatus,
  loading,
  searchRefetch,
  showFromEmployee,
  officeDistrictCodes,
  officeIsLoading,
}) => {
  const [filter, setFilter] = useState(false);
  const [massUploadModal, setMassUploadModal] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [, setIsSearching] = useState(false);
  const [officeExportData, setOfficeExportData] = useState([]);
  const user = useRecoilValue(accountAtom);
  const downloadRef = useRef();
  const {
    mutateAsync: getOfficeForDownload,
    isLoading: officeDownloadLoading,
  } = useOfficeForDownload();
  let location = useLocation();

  const search = location.search;
  const qs = new URLSearchParams(search);
  const qsId = qs.get("id");
  const qsName = qs.get("name");
  if (qsId && searchId === "") {
    setSearchId(qsId);
    setFilter(true);
  }

  if (qsName && searchName === "") {
    setSearchName(qsId);
    setFilter(true);
  }
  const isShow = useRecoilValue(officeShowState);

  const [isAdd, setAddState] = useRecoilState(officeAddState);
  const isEdit = useRecoilValue(officeEditState);
  const tableRef = useRef(0);

  //Permission
  const viewPermission =
    OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_view;
  const addPermission =
    OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_add;
  const userPermissions = useRecoilValue(permissionsSelector);

  //Download - NEW
  const [isDistrictChange, setIsDistrictChange] = useState(false);
  let dateTimeToday = new Date(new Date().toISOString()).toISOString();
  const downloadOfficeReports = (districtChanged) => {
    const dataForDownload = tableRef.current.dataManager.searched
      ? tableRef.current.dataManager.searchedData
      : data;

    //only available for district template
    const districtChange = [
      "updatedDistrictCode",
      "updatedDistrictName",
      "updatedArea",
      "updatedRegion",
      "updatedTerritory",
      "updatedSalesVp",
      "updatedBranchManager",
      "updatedDistrictManager",
    ];

    const excludedColumns = new Set([
      "suiteNumber",
      "addressLineTypeId",
      "addressLineTypeName",
    ]);

    const shouldIncludeColumn = (
      key,
      excludedColumns,
      districtChanged,
      districtChange
    ) =>
      !excludedColumns.has(key) &&
      (districtChanged || !districtChange.includes(key));

    const includeFranchise = user.isFranchise;
    if (!includeFranchise) {
      excludedColumns.add("franchiseOwner");
    }

    const formatDate = (date) =>
      date ? new Date(date).toLocaleDateString("en-US") : "";

    getOfficeForDownload(
      dataForDownload.map((row) => row.officeId),
      {
        onSuccess: (res) => {
          if (res) {
            setOfficeExportData(
              res.map((x) => {
                const officeDownload = {};

                for (const [key, value] of Object.entries(x)) {
                  if (
                    !shouldIncludeColumn(
                      key,
                      excludedColumns,
                      districtChanged,
                      districtChange
                    )
                  ) {
                    continue;
                  }

                  officeDownload[key] = value;
                }
                return {
                  ...officeDownload,
                  createdOn: formatDate(x.createdOn),
                  updatedOn: formatDate(x.updatedOn),
                  officeOpenedDate: formatDate(x.officeOpenedDate),
                  officeClosedDate: formatDate(x.officeClosedDate),
                  officeHierarchyEffectiveDate: formatDate(
                    x.officeHierarchyEffectiveDate
                  ),
                  reOpenDate: formatDate(x.reOpenDate),
                  darkReasonEffectiveDate: formatDate(
                    x.darkReasonEffectiveDate
                  ),
                  originalOpenedDate: formatDate(x.originalOpenedDate),
                  acquisitionDate: formatDate(x.acquisitionDate),
                  relocationDate: formatDate(x.relocationDate),
                  shippingLastVerified: formatDate(x.shippingLastVerified),
                };
              })
            );

            downloadRef.current.link.click();
            !districtChanged
              ? toast.fire(
                  "Download Office Reports",
                  "Office reports downloaded successfully.",
                  "success"
                )
              : toast.fire(
                  "Download District Change Template",
                  "District change template downloaded successfully.",
                  "success"
                );
          }
        },
        onError: (error) => {
          if (error) {
            !districtChanged
              ? toast.fire(
                  "Download Office Reports",
                  "Server Error: Cannot download office reports.",
                  "error"
                )
              : toast.fire(
                  "Download District Change Template",
                  "Server Error: Cannot download district change template.",
                  "error"
                );
          }
        },
      }
    );
  };
  //const exportdata = data && data?.map(({ tableData, ...item }) => item);
  const csvReport = {
    filename: !isDistrictChange
      ? "OfficeModuleReport" + dateTimeToday + ".csv"
      : "DistrictChangeTemplate" + dateTimeToday + ".csv",
    data: officeExportData,
  };

  return (
    <div className="px-8 py-4 min-h-fitmin-h-fit">
      {!isAdd && !isEdit && !isShow ? (
        <div>
          <div className="flex justify-between items-center">
            <div>
              <div className="flex gap-2 items-center">
                <div>
                  <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Office Module
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    All Offices
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div className="text-xs  space-y-2">
            <div className="pt-4 pb-2 flex justify-between ">
              <div className="space-x-4 mr-6">
                <button
                  className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                  gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                  onClick={() => {
                    setFilter(!filter);
                  }}
                >
                  <div>Filter By</div>
                  <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                </button>
              </div>

              <div className=" flex flex-row justify-between gap-2">
                {userPermissions.includes(addPermission) && (
                  <AddButton
                    buttonText="Add"
                    onClick={() => {
                      setAddState(true);
                    }}
                  />
                )}
                {userPermissions.includes(addPermission) && (
                  <MassUploadButton
                    onClickFunction={() => {
                      setMassUploadModal(true);
                    }}
                    className={
                      isAdd || isEdit
                        ? "hidden"
                        : "hover:scale-90 transition duration-500 bg-tranparent border-quaternary shadow-md hover:bg-quaternary text-quaternary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70"
                    }
                  >
                    <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                    Mass Upload
                  </MassUploadButton>
                )}
                {userPermissions.includes(viewPermission) && (
                  <>
                    <DownloadButton
                      disabled={
                        isDistrictChange && officeDownloadLoading ? true : false
                      }
                      buttonValue={
                        isDistrictChange && officeDownloadLoading
                          ? "Downloading..."
                          : "District Change Template"
                      }
                      onClick={() => {
                        downloadOfficeReports(true);
                        setIsDistrictChange(true);
                      }}
                    />
                    <CSVLink
                      className="2xl:-mt-1 hidden"
                      ref={downloadRef}
                      {...csvReport}
                    ></CSVLink>
                    <div className="box-content">
                      <DownloadButton
                        disabled={
                          !isDistrictChange && officeDownloadLoading
                            ? true
                            : false
                        }
                        buttonValue={
                          !isDistrictChange && officeDownloadLoading
                            ? "Downloading..."
                            : "Download File"
                        }
                        onClick={() => {
                          downloadOfficeReports(false);
                          setIsDistrictChange(false);
                        }}
                      />
                      <CSVLink
                        className="2xl:-mt-1 hidden"
                        ref={downloadRef}
                        {...csvReport}
                      ></CSVLink>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* end of buttons */}

      {(isAdd || isEdit) && (
        <div className="w-full">
          <OfficeSettingsForm searchRefetch={searchRefetch} />
        </div>
      )}
      {!massUploadModal && !isAdd && !isEdit ? (
        <main className="flex justify-between ">
          {filter && (
            <div className="overflow-y-auto flex-col flex-grow bg-white">
              <div className="mb-4">
                {!loading && !isAdd && !isEdit && !isShow && (
                  <TableFilters
                    filterOfficeSettings={filterOfficeSettings}
                    setFilterStatus={setFilterStatus}
                    setFilteredOfficeData={setFilteredOfficeData}
                    setresetStatus={setresetStatus}
                    loading={loading}
                    setIsSearching={setIsSearching}
                    filter={filter}
                    officeDistrictCodes={officeDistrictCodes}
                    officeIsLoading={officeIsLoading}
                  />
                )}
              </div>
            </div>
          )}
          {userPermissions.includes(viewPermission) && !isAdd && !isEdit && (
            <div className={`${filter && !isShow ? "w-4/5" : "w-full"}`}>
              <OfficeSettingsTable
                data={data}
                isLoading={loading}
                tableRef={tableRef}
                showFromEmployee={showFromEmployee}
              />
            </div>
          )}
        </main>
      ) : (
        ""
      )}
      {massUploadModal && (
        <MassUpload
          isOpen={massUploadModal}
          setMassUploadModal={setMassUploadModal}
        />
      )}
    </div>
  );
};
export default OfficeSettingsMain;
